module.exports = __webpack_public_path__ + "static/media/delivery.f9aed288.svg";